// # TODO[AC]= map to numbered error codes, instead of string
export enum WidgetAuthErrorEnum {
  // auth key
  InvalidUAID = 'analytic id does not exist',
  InvalidDeveloperId = 'Client id invalid',
  InvalidProductKey = 'app product key',
  MissingUAID = 'analytic id missing',

  // API platform restriction
  WebOnlyAPI = 'Api key only compatible with Web Widget',
  AndroidOnlyAPI = 'Api key only compatible with Mobile Widget SDK for Android',
  IOSOnlyAPI = 'Api key only compatible with Mobile Widget SDK for iOS',

  // product key
  MixedAPIKeys = 'Use of both an app product key and an app api key not allowed',
  ProductKeyNotRegistered = 'App product key "xxx" has not been registered or is incorrect.  Ensure it has been registered by the system admin',
  // eslint-disable-next-line max-len
  ProductKeyInvalidAppBundleID = 'The app product key "xxx" has not been authorized to be used for app bundle id "yyy".  Confirm the correct values are being used from the system admin',
  // eslint-disable-next-line max-len
  ProductKeyBundleIDWhitelist = 'Use of app product key "xxx" requires the affiliated app bundle id (app_domain) to be white-listed.  Ensure the system admin has white-listed "yyy"',
  ImproperProductKeyUsage = 'Improper use of app product key "xxx" detected. Contact the system admin if issue continues',

  // generic errors
  InvalidPlatformSource = 'Invalid platform source',
  MissingSource = 'Missing source',
  MissingPlatform = 'Missing platform',
  MissingAppDomain = 'Missing app domain',
  APIKeyMissing = 'Api key missing',
  APIKeyInvalid = 'Api key invalid',
  DeveloperDeactivated = 'Developer account for api key is deactivated',
  BundleIDNotAllowed = 'App bundle id not allowed',
  BundleIDUnregistered = 'App bundle id unregistered',
}
